import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAuthToken } from "jwt-storage-lib";
import { buildUrlQuery } from "@builder/utils/buildUrlQuery";
import { Product } from "@builder/types/Product.type";

export const productsApi = createApi({
    reducerPath: "productsApi",
    baseQuery: fetchBaseQuery({
        baseUrl: `${import.meta.env.VITE_URL_HUB_API}product`,
        prepareHeaders: async headers => {
            const token = await getAuthToken();

            if (token) {
                headers.set("Authorization", `Bearer ${token}`);
            }

            return headers;
        }
    }),
    tagTypes: ["products"],
    endpoints: builder => ({
        getProducts: builder.query<Product[], { companyId: string; search?: string; offset?: number; limit?: number; organizationId?: string }>({
            query: ({ companyId, ...query }) => `/builder/query/${companyId}?${buildUrlQuery(query)}`,
            providesTags: ["products"]
        }),
        getProductsByIds: builder.query<Product[], { companyId: string; ids: string[]; organizationId?: string }>({
            query: ({ companyId, ids, organizationId }) => {
                const params = new URLSearchParams({ ids: ids.join(",") });
                if (organizationId) {
                    params.append("organizationId", organizationId);
                }
                return `/builder/by-ids/${companyId}?${params.toString()}`;
            },
            providesTags: ["products"]
        })
    })
});

export const { useGetProductsQuery, useGetProductsByIdsQuery } = productsApi;
